import { jwtDecode } from 'jwt-decode';

import { IJwtProvider } from 'modules/authentication/domain/providers';

export default class JwtDecodeJwtProvider implements IJwtProvider {
  public decode: IJwtProvider['decode'] = token => jwtDecode(token);
}
